<template>
  <UApp :toaster="{ position: 'bottom-left', max: 3 }">
    <NuxtLayout>
      <NuxtLoadingIndicator />
      <NuxtRouteAnnouncer />
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>

<script setup lang="ts">
const head = useLocaleHead()
import { useCartStore } from '~/stores/useCartStore'
import { useWishlistStore } from '~/stores/useWishlistStore'
import { useCurrencyStore } from '~/stores/useCurrencyStore'

const cart = useCartStore()
const wishlist = useWishlistStore()
const currencyStore = useCurrencyStore()
const customerStore = useCustomerStore()

// Maybe check cookie
if (!customerStore.customer && !customerStore.loaded) {
  console.log('Loading customer profile on app.vue mount')
  await customerStore.load()
}

onMounted(() => {
  cart.loadCart()
  wishlist.loadWishlist()
  customerStore.load()
})

watch(() => currencyStore.currency, () => {
  cart.loadCart()
  wishlist.loadWishlist()
  refreshNuxtData()
})

watch(() => customerStore.customer, () => {
    cart.loadCart()
    wishlist.loadWishlist()
})

useHead({
  htmlAttrs: {
    lang: head.value.htmlAttrs.lang
  },
  link: [...(head.value.link || [])],
  meta: [...(head.value.meta || [])]
})
</script>
